import axios from 'axios'
import arrOfIcons from '../../components/json/arr_of_icons.json'

const namespaced = true

const state = {
  packageCreated: 0,
  packageEdited: 0,
  dismissCountDown1: 0,
  dismissCountDown2: 0,
  selectVal: {
    current_status: undefined
  },
  consignments: null,
  arrOfIcons: arrOfIcons,
  user: null,
  statuses: null,
  consignmentId: null,
  consignment: null,
  alias: null,
  pid: null,
  customsMessages: null,
  ftsMessages: null,
  ftsMessageHtml: null,
  piApprovedMessageHtml: null,

  cancelToken: null,
  source: null
}

const actions = {
  getFile ({ commit }, payload) {
    const url = payload.file
    return new Promise((resolve, reject) => {
      axios.get(url, { responseType: 'blob' })
        .then(response => {
          response.fileName = payload.name
          commit('downloadFile', response)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getFtsFile (payload) {
    const url = payload.file
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          response.fileName = payload.name
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPiApprovedFtsFile (payload) {
    const url = payload.file
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => {
          response.fileName = payload.name
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getStatuses ({ commit, state }) {
    const url = '/api/private/v4.0/piportals/' + state.alias + '/pitransite-chain-statuses/'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => response.data)
        .then(statuses => {
          commit('parseStatuses', statuses)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadCustomsMessages ({ commit }) {
    axios.get('/api/private/v4.0/list/customs/messages/')
      .then(response => response.data)
      .then(messages => {
        commit('parseCustomsMessages', messages)
      })
      .catch(error => {
        console.log(error)
      })
  },
  loadFtsMessages ({ commit, state }, payload) {
    const url = '/api/private/v4.0/piportals/' + state.alias + '/packages/' + payload.transite_pid + '/pitransite-messages/'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => response.data)
        .then(ftsMessages => {
          commit('parseFtsMessages', ftsMessages)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  showPiApprovedMessageHtml ({ commit }, payload) {
    const url = payload.url
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => response.data)
        .then(piApprovedMessageHtml => {
          commit('parsePiApprovedMessageHtml', piApprovedMessageHtml)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  showFtsMessageHtml ({ commit }, payload) {
    const url = payload.url
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => response.data)
        .then(ftsMessageHtml => {
          commit('parseFtsMessageHtml', ftsMessageHtml)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  createConsignment ({ commit }) {
    const url = '/api/private/v4.0/consignments/'
    return new Promise((resolve, reject) => {
      axios.post(url)
        .then(response => response.data)
        .then(consignment => {
          commit('parseConsignmentId', consignment)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getConsignmentById ({ commit, state }, payload) {
    const url = '/api/private/v4.0/consignments/' + (!payload.consignment_id ? state.consignmentId : payload.consignment_id) + '/'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(response => response.data)
        .then(consignment => {
          commit('parseConsignment', consignment)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  syncFromPiportal ({ state }, payload) {
    const url = '/api/private/v4.0/consignments/' + (!payload.consignment_id ? state.consignmentId : payload.consignment_id) + '/sync-from-piportal/'
    const params = {
      alias: state.alias,
      chain_id: payload.chain_id,
      sync_from: payload.pi_pid
    }
    return new Promise((resolve, reject) => {
      axios.post(url, params)
        .then(() => {
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addConsignmentToPiportal ({ commit, state }, payload) {
    const url = '/api/private/v4.0/consignments/' + (!payload.consignment_id ? state.consignmentId : payload.consignment_id) + '/piportal-upload/'
    const params = {
      alias: state.alias,
      chain_id: payload.chain_id,
      pi_pid: payload.pi_pid
    }
    return new Promise((resolve, reject) => {
      axios.post(url, params)
        .then(response => response.data)
        .then((pid) => {
          commit('parsePid', pid)
          resolve('result')
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loadConsignments ({ commit, state }) {
    commit('setSourceToken')
    const url = '/api/private/v4.0/piportals/' + state.alias + '/pitransite-chains/'
    return new Promise((resolve, reject) => {
      axios.get(url, { cancelToken: state.source.token })
        .then(response => response.data)
        .then(consignments => {
          commit('parseConsignments', consignments)
          resolve('result')
        }).catch(error => {
          if (axios.isCancel(error)) {
            commit('unsetSourceToken')
            console.log('Request canceled: ', error.message)
          } else {
            reject(error)
          }
        })
    })
  },
  addFiles ({ state }, payload) {
    const url = '/api/private/v4.0/consignments/' + (!payload.consignment_id ? state.consignmentId : payload.consignment_id) + '/files/'
    if (payload.files && payload.files.length > 0) {
      const i = 0
      return new Promise((resolve, reject) => {
        const f = function (i) {
          const formData = new FormData()
          formData.append('file', payload.files[i].file)
          axios.post(url, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(() => {
              i++
              if (i < payload.files.length) {
                return f(i)
              } else {
                resolve('result')
              }
            })
            .catch(error => {
              reject(error)
            })
        }
        f(i)
      })
    }
  },
  deleteFiles ({ state }, payload) {
    if (payload.filesToDelete && (payload.filesToDelete.length > 0) && state) {
      const i = 0
      return new Promise((resolve, reject) => {
        const f = function (i) {
          const url = '/api/private/v4.0/consignments/' + payload.consignment_id + '/files/' + payload.filesToDelete[i] + '/'
          axios.delete(url, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(() => {
              i++
              if (i < payload.filesToDelete.length) {
                return f(i)
              } else {
                resolve('result')
              }
            })
            .catch(error => {
              reject(error)
            })
        }
        f(i)
      })
    }
  }
}

const mutations = {
  parseConsignments (state, value) {
    for (let i = 0; i < value.length; i++) {
      value[i].actions = { visible: false }
      value[i].files = null
      value[i].open_documents = false
      value[i].current_status = value[i].status.caption
    }
    state.consignments = value
  },
  parseConsignmentId (state, value) {
    state.consignmentId = value.id
  },
  setCurrentStatus (state, value) {
    state.selectVal.current_status = value
  },
  parseStatuses (state, value) {
    state.statuses = value
  },
  parseConsignment (state, value) {
    if (value.files && value.files.length) {
      for (let q = 0; q < value.files.length; q++) {
        value.files[q].icon = ''
        let ext = ''
        const parts = value.files[q].name.split('.')
        if (parts.length > 1) ext = parts.pop()
        for (const key in state.arrOfIcons) {
          if (ext.toLowerCase().indexOf(key) !== -1) {
            value.files[q].icon = state.arrOfIcons[key]
            break
          }
        }
        if (value.files[q].icon === '') {
          value.files[q].icon = 'file'
        }
        value.files[q].fts = false
      }
    }
    state.consignment = value
  },
  updatePackageCreated (state, value) {
    state.packageCreated = value
  },
  updateDismissCountDown1 (state, value) {
    state.dismissCountDown1 = value
  },
  updatePackageEdited (state, value) {
    state.packageEdited = value
  },
  updateDismissCountDown2 (state, value) {
    state.dismissCountDown2 = value
  },
  parsePid (state, value) {
    state.pid = value.pid
  },
  parseCustomsMessages (state, value) {
    state.customsMessages = value
  },
  parseFtsMessages (state, value) {
    state.ftsMessages = value
  },
  parsePiApprovedMessageHtml (state, value) {
    state.piApprovedMessageHtml = value
  },
  parseFtsMessageHtml (state, value) {
    state.ftsMessageHtml = value
  },
  setServerAlias (state) {
    if (localStorage.getItem('userInfo')) {
      state.alias = JSON.parse(localStorage.getItem('userInfo')).piportals[0].alias
    } else {
      state.alias = 'otvt'
    }
  },
  downloadFile (state, value) {
    const fileName = value.fileName
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      const downloadBlob = new Blob([value.data], { type: value.data.type })
      window.navigator.msSaveOrOpenBlob(downloadBlob, fileName)
    } else {
      try {
        const downloadUrl = window.URL.createObjectURL(new Blob([value.data], { type: value.data.type }))
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          link.remove()
          window.URL.revokeObjectURL(downloadUrl)
        }, 2000)
        link.remove()
      } catch (error) {
        console.log(error)
      }
    }
  },
  setSourceToken (state) {
    state.cancelToken = axios.CancelToken
    state.source = state.cancelToken.source()
  },
  cancelSourceToken (state, value) {
    if (state.source !== null) {
      state.source.cancel(value.message)
    }
  },
  unsetSourceToken (state) {
    state.cancelToken = null
    state.source = null
  },
  setFtsMessageHtml (state, value) {
    state.ftsMessageHtml = value
  },
  setPiApprovedMessageHtml (state, value) {
    state.piApprovedMessageHtml = value
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
